import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import { useCallback, useState } from 'react';
import useMountedState from 'react-use/lib/useMountedState';
import { TABLE_RAIL_IMAGE_URL } from '../assets/themeTableAssetUrls';
import { ALL_THEME_TABLE_PROPERTIES, ALL_THEME_TABLE_TYPES } from '../types/themeTableTypes';
import { loadImage } from '../utils/imageUtils';
import { BUTTON_CONTAINER_CSS } from './devToolsContents';
const IMAGE_WIDTH = 300;
const IMAGE_HEIGHT = 150;
export async function generateTableDataUrls(tableWidth, tableHeight) {
    const railImage = await loadImage(TABLE_RAIL_IMAGE_URL);
    const feltImages = await Promise.all(ALL_THEME_TABLE_TYPES.map((themeTableType) => loadImage(ALL_THEME_TABLE_PROPERTIES[themeTableType].imageUrl)));
    const dataUrls = feltImages.map((feltImage) => {
        const canvas = document.createElement('canvas');
        canvas.width = tableWidth;
        canvas.height = tableHeight;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            throw new Error('Could not get canvas context to render table image');
        }
        ctx.drawImage(railImage, 0, 0, tableWidth, tableHeight);
        const railThickness = Math.round(tableHeight * 0.08);
        const feltWidth = tableWidth - 2 * railThickness;
        const feltHeight = tableHeight - 2 * railThickness;
        const feltX = Math.round((tableWidth - feltWidth) / 2);
        const feltY = Math.round((tableHeight - feltHeight) / 2);
        ctx.drawImage(feltImage, feltX, feltY, feltWidth, feltHeight);
        return ctx.canvas.toDataURL();
    });
    return dataUrls;
}
export const DevToolsTableGraphicsPage = () => {
    const isMounted = useMountedState();
    const [dataUrls, setDataUrls] = useState([]);
    const [tableWidth, setTableWidth] = useState(450);
    const [tableHeight, setTableHeight] = useState(200);
    const onClickMakeTableGraphics = useCallback(async () => {
        const dataUrls = await generateTableDataUrls(tableWidth, tableHeight);
        if (!isMounted()) {
            return;
        }
        setDataUrls(dataUrls);
    }, [tableWidth, tableHeight, isMounted]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { css: BUTTON_CONTAINER_CSS, children: [_jsx(Button, { onClick: onClickMakeTableGraphics, variant: 'contained', children: "Make Table Graphics" }), _jsx("input", { type: 'number', value: tableWidth, onChange: (e) => {
                            setTableWidth(Number(e.target.value));
                        } }), ' ', "x", ' ', _jsx("input", { type: 'number', value: tableHeight, onChange: (e) => {
                            setTableHeight(Number(e.target.value));
                        } })] }), _jsx("div", { css: css `
          display: flex;
          flex-flow: row wrap;
          gap: 5px;
          padding: 20px;
          filter: drop-shadow(8px 8px 0 rgb(0, 0, 0, 0.2));
        `, children: dataUrls.map((dataUrl, i) => {
                    return (_jsx("div", { children: _jsx("img", { src: dataUrl, width: IMAGE_WIDTH, height: IMAGE_HEIGHT }) }, i));
                }) })] }));
};
